var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.553c-1.406.031-2.719-.406-3.844-1.217v5.586c0 3.9-4.25 6.334-7.625 4.4-3.375-1.966-3.375-6.834 0-8.8a5.11 5.11 0 0 1 3.25-.624v2.808c-1.719-.561-3.375.968-3 2.715.406 1.748 2.531 2.434 3.875 1.217.469-.437.75-1.06.75-1.716V8h2.75c0 .25 0 .468.063.718a3.69 3.69 0 0 0 1.687 2.496c.594.406 1.344.624 2.094.624v2.715Z",
    fill: "#151515"
  })));
};
export default SvgTiktok;